<template>
  <div data-intercom-target="Financial News toggle" class="flex flex-col">
    <div class="flex gap-x-2 items-center my-2">
      <ToggleSwitch
        :key="
          'exclude_financial_news-' +
          searchFilterStore?.currentSearchFilter?.exclude_financial_news
        "
        :switch-value="
          searchFilterStore?.currentSearchFilter?.exclude_financial_news ??
          false
        "
        @switch-clicked="onSwitchClicked('exclude_financial_news')"
      />
      <span class="font-body-2">{{ $t("appliedFilters.financialNews") }}</span>
    </div>
    <div
      data-intercom-target="Press Releases toggle"
      class="flex gap-x-2 items-center my-2"
    >
      <ToggleSwitch
        :key="
          'exclude_press_releases-' +
          searchFilterStore?.currentSearchFilter?.exclude_press_releases
        "
        :switch-value="
          searchFilterStore?.currentSearchFilter?.exclude_press_releases ??
          false
        "
        @switch-clicked="onSwitchClicked('exclude_press_releases')"
      />
      <span class="font-body-2">{{ $t("appliedFilters.pressReleases") }}</span>
    </div>
    <div
      data-intercom-target="Market Research toggle"
      class="flex gap-x-2 items-center my-2"
    >
      <ToggleSwitch
        :key="
          'exclude_market_research-' +
          searchFilterStore?.currentSearchFilter?.exclude_market_research
        "
        :switch-value="
          searchFilterStore?.currentSearchFilter?.exclude_market_research ??
          false
        "
        @switch-clicked="onSwitchClicked('exclude_market_research')"
      />
      <span class="font-body-2">{{ $t("appliedFilters.marketResearch") }}</span>
    </div>
    <div
      v-if="searchFilterStore.getCurrentSearchFilter.social_media_type"
      class="flex items-center justify-between"
    >
      <div
        data-intercom-target="Social Mentions with Low Reach toggle"
        class="flex gap-x-2 items-center my-2"
      >
        <ToggleSwitch
          :key="
            'exclude_social_mentions_with_low_reach-' +
            searchFilterStore?.currentSearchFilter
              ?.exclude_social_mentions_with_low_reach
          "
          :switch-value="
            searchFilterStore?.currentSearchFilter
              ?.exclude_social_mentions_with_low_reach ?? false
          "
          @switch-clicked="
            onSwitchClicked('exclude_social_mentions_with_low_reach')
          "
        />
        <span class="font-body-2">{{
          $t("appliedFilters.socialMentionsWithLowReach")
        }}</span>
      </div>
      <el-tooltip
        :content="$t('appliedFilters.turnOffToViewAllSocialMentions')"
        placement="left"
        popper-class="text-white text-sm font-normal font-body-3"
      >
        <font-awesome-icon
          class="w-4 h-4 rounded-full text-secondary-600 focus:outline-none"
          :icon="['far', 'info-circle']"
        />
      </el-tooltip>
    </div>
  </div>
</template>

<script setup lang="ts">
import ToggleSwitch from "~/components/shared/toggle-switch/ToggleSwitch.vue";
import { useSearchFiltersStore } from "~/store/searchFilter";

const searchFilterStore = useSearchFiltersStore();

const emit = defineEmits(["performUpdate"]);

const onSwitchClicked = (type: string) => {
  switch (type) {
    case "exclude_market_research":
      searchFilterStore.currentSearchFilter.exclude_market_research =
        !searchFilterStore?.currentSearchFilter?.exclude_market_research;
      break;
    case "exclude_press_releases":
      searchFilterStore.currentSearchFilter.exclude_press_releases =
        !searchFilterStore?.currentSearchFilter?.exclude_press_releases;
      break;
    case "exclude_financial_news":
      searchFilterStore.currentSearchFilter.exclude_financial_news =
        !searchFilterStore?.currentSearchFilter?.exclude_financial_news;
      break;
    case "exclude_social_mentions_with_low_reach":
      searchFilterStore.currentSearchFilter.exclude_social_mentions_with_low_reach =
        !searchFilterStore?.currentSearchFilter
          ?.exclude_social_mentions_with_low_reach;
      break;
  }
  emit("performUpdate");
};
</script>
